<template>
  <div class="export-pdf-container">
    <div class="content one-page rating-system">
      <div class="content-rating">
        <!--<img class="main-img" :src="'img/imgPdf/rating-system.jpg'" alt="" />-->
        <p class="box-logo-upm">
          <img :src="'img/imgPdf/upm-page1.png'" alt="" />
        </p>
        <div class="box-fact-file">
          <p class="fact-file">Fact file</p>
          <p class="institutional">Institutional Level</p>
        </div>
        <div class="box-uni-name">
          <img
            :src="
              `img/icon-rating/${getStarImg(
                uniData.university_type_id === 1 ? 'research' : 'applied',
                uniSummaryRatingData.star,
                uniSummaryRatingData.extra
              )}`
            "
            alt=""
            class="rating-img"
          />
          <p class="uni-name">{{ uniData.name }}</p>
          <p class="uni-country">{{ uniData.nation }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RatingSystem",
  data() {
    return {
      uniData: {
        name: "",
        nation: "",
        university_type_id: "",
        university_type: {
          name: ""
        }
      },
      uniSummaryRatingData: {
        star: 0,
        extra: null
      }
    };
  },
  props: {
    universityInfo: {
      type: Object
    },
    uniSummaryRating: {
      type: Object
    }
  },
  watch: {
    universityInfo: {
      handler(newVal) {
        this.uniData.name = newVal.name;
        this.uniData.nation = newVal.nation;
        this.uniData.university_type_id = newVal.university_type_id;
        this.uniData.university_type = newVal.university_type;
      },
      deep: true,
      immediate: true
    },
    uniSummaryRating: {
      handler(newVal) {
        this.uniSummaryRatingData.extra = newVal.extra;
        this.uniSummaryRatingData.star = newVal.star;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.uniData.name = this.universityInfo.name;
    this.uniData.nation = this.universityInfo.nation;
    this.uniData.university_type_id = this.universityInfo.university_type_id;
    this.uniData.university_type = this.universityInfo.university_type;
    this.uniSummaryRatingData.extra = this.uniSummaryRating.extra;
    this.uniSummaryRatingData.star = this.uniSummaryRating.star;
  },
  methods: {
    getStarImg(divisionName, star = "", extra = "") {
      const displayStar =
        star && star >= 1 ? Math.floor(star / 1).toFixed(0) : 1;
      return `${divisionName}_${_.toLower(extra)}${displayStar}.png`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/pdf.scss";
</style>
